import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import getLocations$ from '../../../../../requests/get-locations.tsx';
import { type Action, fetchDataSuccess, fetchDataFailure } from '../../action-creators/index.tsx';
import { FETCH_DATA_REQUEST } from '../../action-types/index.tsx';
import type { State } from '../../model.tsx';
import { recentProjectsLimitSelector } from '../../selectors/index.tsx';

const rootEpic = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>,
): ActionsObservable<Action> =>
	// @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<FetchDataSuccessAction | FetchDataFailureAction>' but required in type 'ActionsObservable<Action>'.
	action$
		.ofType(FETCH_DATA_REQUEST)
		.switchMap(() => {
			const state = store.getState();
			return getLocations$(recentProjectsLimitSelector(state));
		})
		.map(fetchDataSuccess)
		.catch(() => Observable.of(fetchDataFailure()));

export default rootEpic;
